import { render } from "./CatalogTeaser.vue?vue&type=template&id=8834884c&scoped=true"
import script from "./CatalogTeaser.vue?vue&type=script&lang=js"
export * from "./CatalogTeaser.vue?vue&type=script&lang=js"

import "./CatalogTeaser.vue?vue&type=style&index=0&id=8834884c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8834884c"]])

export default __exports__